import { Colors } from '@app/config/colors';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { TagManager } from '@app/utils/tag-manager';
import { normalizeCyData } from '@app/utils/tests';
import { RadioGroup } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import cls from 'classnames';
import React from 'react';
import pay from './payment.module.css';

type Props = {
  paymentsAvailable: string[];
  selectedPayment: string | null;
  onSelectedPaymentChange: (payment: string) => void;
};

export default function PaymentTypes({ paymentsAvailable, selectedPayment, onSelectedPaymentChange }: Props) {
  const { primaryColor } = useRestaurantContext();

  return (
    <div className={pay.container}>
      <span className={pay.title}>Forma de Pagamento</span>
      {paymentsAvailable.map((payment) => {
        return (
          <div
            key={payment}
            className={cls(pay.radioSelectItem, TagManager.Classes.AddPaymentInfo)}
            data-cy={normalizeCyData(`payment-${payment}`)}
            onClick={() => onSelectedPaymentChange(payment)}
          >
            <Radio
              checked={selectedPayment === payment}
              value={payment}
              id={payment}
              name={payment}
              style={{ color: primaryColor || Colors.DefaultPrimaryColor }}
              className={TagManager.Classes.AddPaymentInfo}
            />
            <span
              style={{ color: selectedPayment === payment ? primaryColor : '#495057' }}
              className={cls(TagManager.Classes.AddPaymentInfo, pay.radioItemText)}
            >
              {payment}
            </span>
          </div>
        );
      })}
    </div>
  );
}
